import classNames from 'classnames';
import { UserAddress } from '../../../../clients/quipli-service/user/user';
import { Card } from '../../../../components/card/card';
import { Radio } from '../../../../components/radio/radio';
import { Typography } from '../../../../components/typography/typography';
import { formatPhoneNumber, formatAddress } from '../../../../util/util';
import { Button } from '../../../../components/form/button';
import Icon from '../../../../components/icons/icon';

export const AccountAddressCard = ({
  address,
  enableSelect,
  isSelected = false,
  isLocationsModuleEnabled,
  onSelect,
  onEdit,
  onDelete,
}: {
  address: UserAddress;
  enableSelect: boolean;
  isSelected?: boolean;
  isLocationsModuleEnabled: boolean;
  onSelect: (address: UserAddress) => void;
  onEdit: (address: UserAddress) => void;
  onDelete: () => void;
}) => {
  return (
    <>
      <Card
        className={classNames(
          'border-solid border border-grey-300 cursor-pointer hover:border-primary-500 transition-colors duration-200 ease-in-out',
          { 'border-primary-500': isSelected },
        )}
        onClick={() => enableSelect && onSelect(address)}
        data-cy="address-card"
      >
        <div className="flex flex-col gap-2">
          <div className="flex flex-row items-start gap-3">
            {enableSelect && (
              <div className="p-1">
                <Radio
                  name={`${address.type}-address`}
                  isChecked={isSelected}
                  type="ecommercePrimary"
                  dataCy="address-radio-input"
                />
              </div>
            )}

            <div className="grow flex flex-col gap-2">
              <Typography type="text-sm" weight="medium" dataCy="address-name">
                {address.name}
              </Typography>
              {address.companyName && (
                <Typography type="text-sm" dataCy="address-company-name">
                  Company name: {address.companyName}
                </Typography>
              )}
              <Typography type="text-sm" dataCy="address-phone">
                {formatPhoneNumber(address.phone)}
              </Typography>
              <Typography type="text-sm" dataCy="address-details">
                {address.address1 != '-1'
                  ? address.address1
                  : isLocationsModuleEnabled
                  ? address.customDeliveryLocation
                  : ''}
                {formatAddress({
                  ...address,
                  address1: '', // Remove the address1 from the address object
                })}
              </Typography>
            </div>

            <div className="flex flex-row">
              <Button
                className="icon-button"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit(address);
                }}
                dataCy="address-edit-button"
              >
                <Icon icon="Edit" stroke="var(--grey-400)" />
              </Button>

              <Button
                className="icon-button"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete();
                }}
                dataCy="address-delete-button"
              >
                <Icon icon="Trash" stroke="var(--grey-400)" />
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};
